import React, { useState } from 'react';
import './SpotlightGallery.css';
import mosquenight from '../../assets/audio/images/mosquenight.jpg';
import masjid1 from '../../assets/audio/images/masjid1.jpg';
import masjid4 from '../../assets/audio/images/masjid4715.jpg';

// Add your spotlight items: type 'image' (src = image URL/path) or 'video' (src = YouTube embed/watch URL or direct mp4)
const SPOTLIGHTS = [
  { id: 1, type: 'video', src: 'https://ik.imagekit.io/zakariamasjid/spotlight/eidmilam.webm', title: 'Eid Milan' },
  {
    id: 2,
    type: 'video',
    src: 'https://ik.imagekit.io/zakariamasjid/spotlight/WhatsApp%20Video%202026-02-14%20at%207.44.20%20PM%20(1).mp4',
    title: 'Spotlight video',
  },
  { id: 3, type: 'video', src: 'https://ik.imagekit.io/zakariamasjid/spotlight/WhatsApp%20Video%202026-02-25%20at%202.14.57%20AM%20(1).mp4', title: 'Spotlight video' },
  {
    id: 4,
    type: 'video',
    src: 'https://ik.imagekit.io/zakariamasjid/spotlight/WhatsApp%20Video%202026-02-25%20at%202.13.17%20AM%20(1)%20(1).mp4',
    title: 'Spotlight video',
  },
];

const isYoutubeUrl = (url) =>
  typeof url === 'string' &&
  (url.includes('youtube.com') || url.includes('youtu.be/'));

const toYoutubeEmbed = (url) => {
  if (!url) return '';
  if (url.includes('youtube.com/embed')) return url;
  const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s?]+)/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : url;
};

const SpotlightGallery = () => {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section className="spotlight-section">
      <div className="spotlight-background" style={{ backgroundImage: `url(${mosquenight})` }} />
      <div className="spotlight-container">
        <div className="spotlight-header" role="banner">
          <span className="spotlight-category">Moments & memories</span>
          <h2 className="spotlight-title">Our Spotlights</h2>
          <p className="spotlight-subtitle">Images and videos from our community and events</p>
        </div>
        <div className="spotlight-grid">
          {SPOTLIGHTS.map((item) => (
            <div key={item.id} className="spotlight-item">
              <div className="spotlight-item-inner">
                {item.type === 'image' ? (
                  <button
                    type="button"
                    className="spotlight-media-wrap spotlight-image-wrap"
                    onClick={() => setLightbox({ type: 'image', src: item.src, title: item.title })}
                  >
                    <img src={item.src} alt={item.title || 'Spotlight'} className="spotlight-image" loading="lazy" />
                    <span className="spotlight-play-icon" aria-hidden><i className="fas fa-search-plus" /></span>
                  </button>
                ) : (
                  <div className="spotlight-media-wrap spotlight-video-wrap">
                    {isYoutubeUrl(item.src) ? (
                      <iframe
                        src={toYoutubeEmbed(item.src)}
                        title={item.title || 'Spotlight video'}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="spotlight-iframe"
                      />
                    ) : (
                      <video
                        src={item.src}
                        controls
                        playsInline
                        className="spotlight-video"
                        poster=""
                        title={item.title}
                      >
                        Your browser does not support the video tag.
                      </video>
                    )}
                  </div>
                )}
                {item.title && <p className="spotlight-item-title">{item.title}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
      {lightbox && lightbox.type === 'image' && (
        <div
          className="spotlight-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label="Image view"
          onClick={() => setLightbox(null)}
        >
          <button type="button" className="spotlight-lightbox-close" onClick={() => setLightbox(null)} aria-label="Close">
            <i className="fas fa-times" />
          </button>
          <img src={lightbox.src} alt={lightbox.title || ''} onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </section>
  );
};

export default SpotlightGallery;
